import React from 'react';

import { UserRole } from 'model/user-role.enum';

import ClassificationDefinitions from './ClassificationDefinitions';
import StorehouseDefinitions from './StorehouseDefinitions';
import TypeDefinitions from './TypeDefinitions';

interface KDDListItem {
  label: string;
  Component?: React.ComponentType;
  path: string;
  visibleTo?: UserRole[];
}

export default [
  {
    label: 'KKD Ana Grup',
    Component: ClassificationDefinitions,
    path: '',
    visibleTo: [UserRole.SYS_ADMIN, UserRole.OSS, UserRole.FIRM_ADMIN],
  },
  {
    label: 'KKD Alt Grup',
    Component: TypeDefinitions,
    path: 'kkdtipi',
    visibleTo: [UserRole.SYS_ADMIN, UserRole.OSS, UserRole.FIRM_ADMIN],
  },
  {
    label: 'Depo Tanımı ve Sorumlusu',
    Component: StorehouseDefinitions,
    path: 'storehouse-definitions',
    visibleTo: [UserRole.SYS_ADMIN, UserRole.OSS, UserRole.FIRM_ADMIN],
  },
] as KDDListItem[];
